import { AfterContentChecked, AfterViewInit, SimpleChanges, ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, OnChanges, OnDestroy, ViewChildren, QueryList, ElementRef, ViewChild } from '@angular/core';
import { element } from 'protractor';
import { AdminAction } from 'src/app/models/adminaction.model';
import { ComponentheaderService } from 'src/app/services/componentheader.service';
import { UtilService } from 'src/app/services/util.service';
import * as XLSX from 'xlsx';

declare var $: any;
@Component({
  selector: 'app-tablelayout',
  templateUrl: './tablelayout.component.html',
  styleUrls: ['./tablelayout.component.css']
})
export class TablelayoutComponent implements OnInit, OnChanges, OnDestroy { //to use this compnent, shadow the implementation on activity log component for reference
  @Input() data = []; // data to display on table.
  @Input() filterItems: Array<any>; //loads the filter criteria
  @Output() loadDataEvent = new EventEmitter<any>(); // fires the eventhandler that loads the data
  @Output() rowClicked = new EventEmitter<any>();
  @Input() count: number = 0; //the total number of data records
  @Input() columnsToRemove: Array<any>; //the property of the data type that you don't want a column created for.
  @Input() offset = 25; //number of records to load at a time
  @Input() allowMultiSelect = false;
  @Input() allowExport = false;
  @Input() selectBy = '';
  @Input() operation: Operation[];
  @Input() noRecordText = "No records";
  @Output() onItemSelected: EventEmitter<string[]> = new EventEmitter<string[]>();
  @Output() onOperationActionFired: EventEmitter<Operation> = new EventEmitter<Operation>();
  filterTimeout: any; // store debounce timer
  displayedData: Array<any> = [];
  currentPage = 0;
  scrollingFunction;
  isLoading: boolean = false;
  enableOperation: boolean = false;
  public operationButtonTypeEnum = OperationButtonType;
  @ViewChildren('selectrow') selectRows!: QueryList<ElementRef<HTMLInputElement>>;
  @ViewChild('operationdropdown') operationdropdown!: ElementRef<any>;
  @ViewChild('tableElement') tableElement: ElementRef<any>;
  isAllRowsSelected: boolean;
  resultDone = false;
  exportFuct;
  exportText = 'Export Table';
  exportDownloadProgress: number;
  writingToExcelText = '';
  tableOperationsForAdmin;

  constructor(public util: UtilService, public headerInfo: ComponentheaderService) { 
  }

  get scrollingBody() {
    let scrollingbody = document.getElementById('home-main-wrap');
    if (window.innerWidth <= 767) {//767 because that's the value used in home.component.css
      scrollingbody = scrollingbody.parentElement;
    }
    return scrollingbody;
  }
  async ngOnInit() {
    await this.LoadData();    
    this.scrollingFunction = this.onScroll.bind(this);
    this.scrollingBody.addEventListener('scroll', this.scrollingFunction);
  }

  async export() {
    this.headerInfo.pageLoadingStarted(this);
    try {
      await this.LoadData();
      $("#progressmodal").modal("show");
      let checkResultOnInterval = setInterval(async () => {
        if (this.displayedData[0].count == this.displayedData.length) {
          clearInterval(checkResultOnInterval);
          this.writeAndDownloadXLSX();
          location.reload();
        }
        else{
          await this.LoadData();
        } 
      }, 2000);
    }
    finally{
      this.isLoading = false;
      this.headerInfo.pageLoadingDone(this);
    }
  }

  writeAndDownloadXLSX(){
    this.writingToExcelText = 'creating excel sheet';
    const workSheet = XLSX.utils.table_to_sheet(this.tableElement.nativeElement);
    const workBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workBook, workSheet);
    this.writingToExcelText = 'writing to excel sheet... kindly wait';
    const excelBuffer = XLSX.write(workBook, { bookType: 'xlsx', type: 'array' });
    const data = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    const url = window.URL.createObjectURL(data);
    $("#progressmodal").modal("hide");
    window.open(url);
  }

  ngOnChanges(change: SimpleChanges) {    
    if ('data' in change) {      
      //adding new data
      if (this.data?.length > 0 && this.data){
        this.displayedData = [...this.displayedData, ... this.data]
      }
      else if (this.data?.length == 0){
          this.resultDone = true;        
          this.displayedData = [];
      }
      
      this.isLoading = false;

      {// ensuring that the latest context state of 'this' is updated in the export callback
        this.exportFuct = this.export.bind(this);
        let exportAction = this.headerInfo.headerDisplay.adminactions.find(a => a.displaytext == this.exportText)
        if(exportAction)
          exportAction.callback = this.exportFuct 
      }
      this.exportDownloadProgress = Math.ceil( (this.displayedData?.length/this.count) * 100 )
    }
    if ('count' in change) {
      console.log(this.count);
    }
    this.setupAdminActions();
  }
  
  setupAdminActions(){        
    if(this.allowMultiSelect && this.operation?.length > 0 && this.displayedData?.length > 0){     
      this.operation.forEach(op =>{
        if(!this.headerInfo.headerDisplay.adminactions.some(o => o.displaytext == op.Title)){
          if(op.Type == this.operationButtonTypeEnum.Button){
            this.headerInfo.headerDisplay.adminactions.push({displaytext: op.Title, callback: () => this.performOperationAction(op), isTableAction: true, disabled: true, classes: op.fasClass});
          }
          else if( op.Type == this.operationButtonTypeEnum.Dropdown){
            let childrenActions = [];

            op.ChildOperation.forEach(child =>{
              if(child.Type == this.operationButtonTypeEnum.DropDownItem){
                childrenActions.push({displaytext: child.Title, callback: () => this.performOperationAction(child), isTableAction: true, classes: []});
              }
            });

            this.headerInfo.headerDisplay.adminactions.push({displaytext: op.Title, isTableAction: true, disabled: true, classes: op.fasClass, childrenActions: childrenActions});
          }
        }
        else{
          console.warn(`${op.Title} already exists in Admin actions. Possible duplicated prevented`)
        }
      });
    }
    
    if(this.allowExport && !this.headerInfo.headerDisplay.adminactions.some(o => o.displaytext == this.exportText)){
      let action = {displaytext: this.exportText,  classes: ['fas', 'fa-cloud-download-alt']};
      this.headerInfo.headerDisplay.adminactions.push(action);
    }
  }

  async onScroll() {    
    if (this.needsMoreDataOnScreen() && !this.resultDone && !this.isLoading && this.count != this.displayedData.length) {
      await this.LoadData();
    }
  }
  needsMoreDataOnScreen() {
    const s = $(this.scrollingBody).scrollTop(),
      d = this.scrollingBody.scrollHeight,
      c = $(this.scrollingBody).height();
    const scrollPercent = (s / (d - c)) * 100;
    return scrollPercent > 75;
  }

  ngOnDestroy(): void {
    this.scrollingBody.removeEventListener('scroll', this.scrollingFunction);
  }

  async LoadData(clearDisplayedData = false) {    
    if (!this.isLoading) {      
      this.isLoading = true;
      this.currentPage++;
      if (this.currentPage == 0 || clearDisplayedData) {
        this.displayedData = [];
      }

      //fires the eventHandler that loads data
      this.loadDataEvent.emit(
        {
          page: this.currentPage,
          offset: this.offset,
          filters: this.filterItems
        }
      );
    }
  }

  setValueForDropdownFilter(data: any, label: string) {
    let filter = this.filterItems.find(f => f.label == label);
    filter.value = data;
    this.currentPage = 0;
    this.onFilterInputChange();
  }

  isValidDate(value: any): boolean {
    if (typeof value === 'string') {
      const dateValue = new Date(value);
      return !isNaN(dateValue.getTime());
    }
    return false;
  }
  shouldDisplayColumn(value: string): boolean {
    return !this.columnsToRemove.includes(value);
  }

  async onFilterInputChange(option = null, value = '') {
    if(option){
      option.value = value;
    }

    if(this.filterTimeout){
      clearTimeout(this.filterTimeout);
    }

    this.filterTimeout = setTimeout
    (async () => 
      {
        await this.reload();
      } 
    , 2000);
  }
  async reload(){
    this.currentPage = 0;
    this.resultDone = false;
    await this.LoadData(true);
  }
  filterHasValue() {
    return !this.filterItems.some(f => f.value)
  }
  clearFilter() {
    location.reload();
  }
  onCheckBoxClicked(e) {
    this.multiSelect(e);
   
    let selected: string[] = this.selectRows.filter(item => item.nativeElement.checked)
      .map(item => this.displayedData[item.nativeElement.id][this.selectBy]);// selectBy would be the column which we want to retrieve its values

    this.enableOperation = this.selectRows.some(i => i.nativeElement.checked);  
    if(this.tableOperationsForAdmin == null)
      this.tableOperationsForAdmin = this.headerInfo.headerDisplay.adminactions.filter(action => action.isTableAction);
    this.tableOperationsForAdmin.map(action => action.disabled = !this.enableOperation);
    this.onItemSelected.emit(selected.filter(i => i != undefined));
  }

  private multiSelect(e){
    if (e.target.id === 'headselect') {
      if (e.target.checked) 
        this.setCheckBoxes(true);      
      else 
        this.setCheckBoxes(false);      
    }else if(this.isAllRowsSelected && !e.target.checked){ 
      this.setCheckBoxes(false);
      document.getElementById('headselect')['checked'] = false;      
    }
  }
  private setCheckBoxes(value: boolean){
    this.selectRows.forEach(input => {
      input.nativeElement.checked = value;
    });
    this.isAllRowsSelected = value;
  }

  actionsDropdownClicked() {
    setTimeout(
      (() => {
        if (
          this.operationdropdown.nativeElement.getAttribute('aria-expanded') == 'true'
        ) {
          $(this.operationdropdown.nativeElement.querySelector('i')).addClass(
            'fa-caret-up'
          );
          $(this.operationdropdown.nativeElement.querySelector('i')).removeClass(
            'fa-caret-down'
          );
        } else {
          $(this.operationdropdown.nativeElement.querySelector('i')).addClass(
            'fa-caret-down'
          );
          $(this.operationdropdown.nativeElement.querySelector('i')).removeClass(
            'fa-caret-up'
          );
        }
      }).bind(this),
      1
    );
  }

  performOperationAction(operation: Operation){        
    if(this.enableOperation){      
      this.onOperationActionFired.emit(operation);
      operation.invokeCallback();
    }     
  }

  rowClick(item: any){
    this.rowClicked.emit(item);
  }
}

export class Operation{
    public Id: any;
    public Title: string;
    public Type: OperationButtonType;
    public ChildOperation: Operation[];
    public fasClass: string[];
    // public CallBack(callback: () => void): void {
    //   console.log('Operations Callback fired');      
    //   callback();
    // }
    public CallBack: (() => void) | null;
    
    constructor(title: string, type: OperationButtonType, fasClass:string[], children: Operation[] = null, callback: (() => void) | null = null, id = null) {
      this.Id = id;
      this.Title = title;
      this.Type = type;
      this.ChildOperation = children;
      this.fasClass = fasClass;
      this.CallBack = callback ? callback.bind(this) : null;
    }

    public invokeCallback(): void {
      if (this.CallBack) {
        console.log('Operations Callback fired');
        this.CallBack();
      }
    }
}

export enum OperationButtonType{
  Button,
  Dropdown,
  DropDownItem
}
